import { Environment } from '../environments';
import { buildBiwApiRootUri } from './buildBiwApiRootUri';
import { buildUri } from './utils/buildUri';

const ID_SERVICE_PATH = '/v1/id';

export const buildIdServiceUri = ( env ) => (
    buildUri(
        [ buildBiwApiRootUri( env ), ID_SERVICE_PATH ],
        { env: ( env !== Environment.PROD ) ? env : '' },
    )
);
